"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-props-no-spreading */
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var AntTimeRangePicker = antd_1.TimePicker.RangePicker;
var RangePicker = function (props) {
    var error = props.error, restProps = __rest(props, ["error"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AntTimeRangePicker, __assign({}, restProps)),
        error && react_1.default.createElement("span", { style: { color: "red", marginBottom: 8 } }, error)));
};
exports.default = react_1.default.memo(RangePicker);
RangePicker.defaultProps = {
    size: "middle",
    format: "HH:mm",
    inputReadOnly: true,
};
